import React from 'react';
import useFetchData from '../../../hooks/useFetchData';
import AutocompleteField from '../input/AutocompleteField';
import { objectToQueryString } from '../../Dashboard/DataEntry/helpers/objectToQueryString';

const AutocompleteFieldTemplateSurvey = ({
  onChange,
  value,
  name,
  error,
  label,
  id,
  helperText,
  filter,
  isPreview
}) => {
  const {
    isLoading,
    data,
    error: errorFetch
  } = useFetchData(
    `/data-entry/templates?type=survey&skip=0&limit=100000&active=true&${objectToQueryString(filter)}`
  );

  return (
    <AutocompleteField
      id={`${id}-autocomplete-survey`}
      label={label}
      name={name}
      placeholder='Template'
      disabled={isLoading || isPreview || errorFetch}
      options={
        data?.paginatedResults.map((el) => ({
          ...el,
          label: el.title,
          value: el._id
        })) || []
      }
      loading={isLoading}
      error={errorFetch || error}
      helperText={errorFetch?.message || helperText}
      onChange={onChange}
      value={value}
    />
  );
};

export default AutocompleteFieldTemplateSurvey;
